// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".inactive-reactive-menu.dropdown-menu[data-v-ff53ccb4] {\n  padding: 0 !important;\n  max-height: 400px;\n  overflow-y: auto;\n  background: #fff;\n}\n.el-table th > .cell[data-v-ff53ccb4] {\n  font-size: 12px;\n  font-weight: 600;\n}", ""]);
// Exports
module.exports = exports;
